import React from 'react';

import { Svg } from '@lglp/components';

import styles from './DefaultInterviewIcon.module.scss';

const DefaultInterviewIcon: React.FC<DefaultInterviewIconProps> = ({
  className,
  ...rest
}) => {
  return (
    <Svg
      viewBox="0 0 83 83"
      className={[styles.defaultInterviewIcon, className]}
      {...rest}
    >
      <circle cx="41.5" cy="41.5" r="41.5" className={styles.whiteFill} />
      <g id="Intersection_2" fill="#ffe271">
        <path
          d="M-16609.502 82c-5.996 0-11.768-1.28-17.156-3.802-2.582-1.21-5.047-2.701-7.324-4.432-2.153-1.637-4.149-3.494-5.936-5.526.557-7.596 3.91-14.652 9.47-19.909 5.684-5.372 13.124-8.33 20.946-8.33 7.824 0 15.264 2.959 20.947 8.33 5.563 5.257 8.916 12.314 9.471 19.91-1.787 2.032-3.783 3.89-5.936 5.525-2.277 1.731-4.742 3.222-7.326 4.432-5.386 2.523-11.16 3.802-17.156 3.802z"
          className={styles.noStroke}
          transform="translate(16651)"
        />
        <path
          d="M-16609.502 81c5.85 0 11.479-1.247 16.732-3.708 2.52-1.18 4.924-2.634 7.145-4.322 1.988-1.511 3.84-3.215 5.51-5.074-.627-7.187-3.85-13.85-9.125-18.838-5.498-5.195-12.694-8.057-20.262-8.057-7.566 0-14.76 2.861-20.258 8.057-5.277 4.987-8.498 11.65-9.127 18.837 1.67 1.859 3.522 3.563 5.51 5.074 2.22 1.689 4.625 3.143 7.145 4.323 5.253 2.46 10.882 3.708 16.73 3.708m0 2c-12.566 0-23.832-5.587-31.441-14.414.99-16.505 14.69-29.585 31.441-29.585 16.756 0 30.455 13.08 31.443 29.586-7.609 8.825-18.875 14.413-31.443 14.413z"
          transform="translate(16651)"
        />
      </g>
      <path
        d="M-16638.865 25.335a29.052 29.052 0 0 1 19.3-7.335 29.034 29.034 0 0 1 18.6 6.73 21 21 0 0 1-19.1 12.265 21 21 0 0 1-18.8-11.66z"
        className={styles.whiteFill}
        transform="translate(16661.055 18)"
      />
      <g id="Ellipse_59" fill="none" stroke="#ffcb05" strokeWidth="2px">
        <circle cx="41.5" cy="41.5" r="41.5" className={styles.noStroke} />
        <circle cx="41.5" cy="41.5" r="40.5" className={styles.noFill} />
      </g>
      <g
        fill="#ffcb05"
        stroke="#ffcb05"
        strokeWidth="2px"
        transform="translate(23 16)"
      >
        <circle cx="18" cy="18" r="18" className={styles.noStroke} />
        <circle cx="18" cy="18" r="17" className={styles.noFill} />
      </g>
    </Svg>
  );
};

type DefaultInterviewIconProps = {
  className?: string;
};

export default DefaultInterviewIcon;
